"use client";

import { useEffect } from "react";

export default function PopupClient() {
  useEffect(() => {
    const popup = document.getElementById("popup");
    const closeBtn = document.getElementById("close-popup");
    const content = popup?.querySelector(".popup-content");

    if (!popup || !closeBtn || !content) return;

    const handleClose = () => popup.classList.add("hidden");

    closeBtn.addEventListener("click", handleClose);

    const handleOutsideClick = (e) => {
      if (!content.contains(e.target)) popup.classList.add("hidden");
    };

    document.addEventListener("click", handleOutsideClick);

    return () => {
      closeBtn.removeEventListener("click", handleClose);
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  return null;
}
